import { jwtDecode } from "jwt-decode"
import { signOut } from "next-auth/react";

/**
 * Valida que `token`:
 *  1. Tenha exatamente 3 partes separadas por '.'
 *  2. Cada parte seja Base64URL (A–Z a–z 0–9 - _)
 *  3. Header e Payload decodificam para JSON válido
 */
export function assertJwtCompactSerialization(token: string) {
    const ERR = "This tool only supports a JWT that uses the JWS Compact " +
        "Serialization, which must have three base64url-encoded " +
        "segments separated by two period ('.') characters as defined " +
        "on RFC 7515";

    const parts = token.split('.');
    if (parts.length !== 3) {
        throw Error(ERR);
    }

    const b64url = /^[A-Za-z0-9_-]+$/;
    const decode = (str: string) => {
        let b64 = str.replace(/-/g, '+').replace(/_/g, '/');
        const pad = b64.length % 4;
        if (pad) b64 += '='.repeat(4 - pad);
        return Buffer.from(b64, 'base64').toString('utf8');
    };

    parts.forEach((part, i) => {
        if (!b64url.test(part)) {
            throw Error(ERR);
        }
        let txt: string;
        try {
            txt = decode(part);
        } catch {
            throw Error(ERR);
        }
        if (i < 2) {
            try {
                JSON.parse(txt);
            } catch {
                throw Error(ERR);
            }
        }
    });
}

const checkJwtExpired = (accessToken: string) => {
    try {
        if (!accessToken) 
            return true;

        const decoded = jwtDecode(accessToken) as any

        if (!decoded?.sub)
            throw Error("Não foi possível obter o código do usuário.")

        let exp = new Date(decoded.exp * 1000)
        let now = new Date()
        let isExpired = exp < now

        return isExpired;
    }
    catch (e) {
        console.warn("Falha ao decodificar token.", (e as Error).message)
    }

    return true
}


export const jwtExpiredClient = async (accessToken: string) => {
    try {
        assertJwtCompactSerialization(accessToken)
    }
    catch (e) {
        await signOut({ redirect: false })
        throw Error((e as Error).message)
    }

    return checkJwtExpired(accessToken)
}

export const jwtExpiredServer = (accessToken: string) => {
    return checkJwtExpired(accessToken)
}